import { useTheme } from '../../../../theme';
import { BodyS } from '../../../../typography';

import type { JSX } from 'react';

type Props = {
  title: string;
  className?: string;
};

export const NotificationTitle = ({ title, className }: Props): JSX.Element => {
  const theme = useTheme();
  return (
    <BodyS
      color={theme.text.generic.primary}
      fontWeight='medium'
      className={className}
      css={{
        paddingRight: theme.spacing(1),
      }}
    >
      {title}
    </BodyS>
  );
};
